export default __webpack_public_path__ + "static/media/creative.64127ffa.png";